import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Currency } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';
import { getIsGreaterChinaSalesOrg } from '../../gamedayAccount/selectors';

const PdpPrice = ({ isGreaterChinaSalesOrg, selectedProductPrices }) => (
  <div className='body-3 pt2-sm prl7-sm pb5-md prl0-md pt0-md pt5-sm' itemScope itemType='http://schema.org/Offer'>
    <div data-desc='pdp__cost_wholesale'>
      <TranslatedCopy id='global.product.wholesale.price' />
      {': '}
      <span itemProp='price'>
        <Currency value={selectedProductPrices.wholesale} type={selectedProductPrices.currency} />
      </span>
    </div>
    {!isGreaterChinaSalesOrg && (
      <div className='text-color-secondary' data-desc='pdp__cost_retail'>
        <TranslatedCopy id='global.product.retail.price' />
        {': '}
        <Currency value={selectedProductPrices.retail} type={selectedProductPrices.currency} />
      </div>
    )}
  </div>
);

PdpPrice.propTypes = {
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired,
  selectedProductPrices: PropTypes.shape({
    currency: PropTypes.string.isRequired,
    retail: PropTypes.number.isRequired,
    wholesale: PropTypes.number.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

export default connect(mapStateToProps, {})(PdpPrice);
